export const shouldLoad = () => document.querySelector('.klt-content-block--pages') !== undefined;